import {
  all,
  call,
  put,
  race,
  select,
  take,
  takeLatest,
} from 'redux-saga/effects';

import quoteItemService from 'modules/quotes/quoteItems/data/service';

import partService from 'services/partService';

import {
  bomRestructuringDrawer,
  moveNodeDown,
  moveNodeUp,
  types,
} from './actions';
import { getQuoteItemId } from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN, watchInitializeDrawer);
  yield takeLatest(types.MOVE_NODE_UP_REQUEST, watchMoveNodeUp);
  yield takeLatest(types.MOVE_NODE_DOWN_REQUEST, watchMoveNodeDown);
}

function* watchInitializeDrawer(action) {
  try {
    const { callBack } = action.payload;

    yield race({
      moveDownSuccess: take(types.MOVE_NODE_DOWN_SUCCESS),
      moveUpSuccess: take(types.MOVE_NODE_UP_SUCCESS),
      cancel: take(types.CLOSE),
    });
    yield put(bomRestructuringDrawer.close());

    if (callBack) {
      yield call(callBack);
    }
  } catch (error) {
    yield put(open.error(error));
  }
}

function* watchMoveNodeDown({ payload }) {
  try {
    const { destinationPartUuid, nodes } = payload;
    yield call(partService.restructureBom, destinationPartUuid, {
      nodes,
    });
    yield put(moveNodeDown.success());
  } catch (e) {
    console.error('Error in watchMoveNodeDown', e);
    yield put(moveNodeDown.error(e));
  }
}

function* watchMoveNodeUp({ payload }) {
  try {
    const { grandParentPartUuid, parent, nodes, copyComponents } = payload;
    if (parent.isRootComponent) {
      // if the parent is the root component we need to create new components
      yield all(
        copyComponents.map(({ componentId, quantityMultiple }) =>
          call(quoteItemService.components.copyToQuoteItem, componentId, {
            quantityMultiple,
          }),
        ),
      );
      const quoteItemId = yield select(getQuoteItemId);
      // delete all nodes with an origin quantity of 0
      const nodeIdsToBeDeleted = nodes
        .filter((node) => node.originQuantity === 0)
        .map(({ id }) => id);
      if (nodeIdsToBeDeleted.length) {
        yield call(quoteItemService.deleteComponents, quoteItemId, {
          nodeIds: nodeIdsToBeDeleted,
        });
      }
      // update quantities of all nodes with remaining origin
      const nodesToBeUpdated = nodes.filter((node) => node.originQuantity > 0);
      if (nodesToBeUpdated.length) {
        yield call(quoteItemService.bulkUpdatePartNodeQuantity, quoteItemId, {
          nodes: nodesToBeUpdated.map((node) => ({
            id: node.id,
            count: node.originQuantity,
          })),
        });
      }
    } else {
      yield call(partService.restructureBom, grandParentPartUuid, {
        nodes,
      });
    }

    yield put(moveNodeUp.success());
  } catch (e) {
    console.error('Error in watchMoveNodeUp', e);
    yield put(moveNodeUp.error(e));
  }
}
